<!-- login.component.html -->
<div class="container-fluid min-vh-100 d-flex align-items-center justify-content-center login-background">
  <div class="card shadow-lg p-4 login-card">
    <div class="text-center logo-container">
      <img src="assets/media/logos/plus_physio_Logo.png" alt="PlusPhysio Logo" class="img-fluid logo-spacing"
        *ngIf="shared.domainType == 'physio'">
      <img src="assets/media/logos/PlusDoctorLogo.png" alt="PlusPhysio Logo" class="img-fluid logo-spacing"
        *ngIf="shared.domainType == 'doctor'">
      <img src="assets/media/logos/Plus-Radiology.png" alt="PlusRadiology Logo" class="img-fluid logo-spacing"
        *ngIf="shared.domainType == 'radiology'">
    </div>
    <div [ngClass]="{'dis_none': is_popup_open}">
      <div *ngIf="isMaintenance && isInTime" class="message-box-container mb-5">
        <pre class="message-box-content">{{ MessageBox }}</pre>
      </div>

      <h5 class="text-center fw-bold" *ngIf="!isSignUp"><b>Sign in</b></h5>
      <p class="text-muted mb-4 text-center" *ngIf="!isSignUp">{{'Enter credentials to signin' | translate}}</p>

      <div class="text-center mb-4" *ngIf="isSignUp">
        <h5 class="fw-bold"><b>Try free sign-up</b></h5>
      </div>

      <form [formGroup]="loginForm">

        <div *ngIf="!isOtpLogin && !isSignUp">
          <div class="mb-3">
            <mat-form-field class="example-full-width">
              <mat-label>{{'Email' | translate}}</mat-label>
              <input matInput type="text" formControlName="Email" autocomplete="off" required
                (input)="loginForm.get('Email').markAsTouched()" />
              <mat-icon matSuffix>person</mat-icon>
              <mat-error *ngIf="isControlHasError('Email', 'required')">
                <strong>{{ 'This field is required' | translate }}</strong>
              </mat-error>
              <mat-error *ngIf="isControlHasError('Email', 'pattern')">
                <strong>{{ 'Please enter a valid email address' | translate }}</strong>
              </mat-error>
            </mat-form-field>
          </div>

          <div class="mb-2">
            <mat-form-field class="example-full-width" appearance="fill">
              <mat-label>{{ 'Password' | translate }}</mat-label>
              <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="Password" autocomplete="off"
                required />
              <button mat-icon-button matSuffix type="button" (click)="togglePasswordVisibility()">
                <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
              </button>
              <mat-error *ngIf="isControlHasError('Password', 'required')">
                <strong>{{ 'This field is required' | translate }}</strong>
              </mat-error>
              <mat-error *ngIf="isControlHasError('Password', 'minlength')">
                <strong>{{ 'Password must be atleast 6 characters' | translate }}</strong>
              </mat-error>
            </mat-form-field>
          </div>
          <div class="mb-1 d-flex justify-content-between align-items-center">
            <!-- Remember Me checkbox (only shown on Android) -->
            <div *ngIf="isAndroidApp">
              <mat-checkbox formControlName="rememberMe">
                {{ 'Remember Me' | translate }}
              </mat-checkbox>
            </div>

            <!-- Empty div when checkbox is hidden to keep spacing -->
            <div *ngIf="!isAndroidApp"></div>

            <!-- Forgot Password link -->
            <a class="kt-link kt-login__link-forgot forgotFontSize" routerLink="/ForgetPasswordEmailVerification">
              {{ 'Forgot your password ?' | translate }}
            </a>
          </div>
        </div>

        <!-- Sign Up Fields -->
        <div *ngIf="isSignUp">
          <div class="mb-3">
            <mat-form-field class="example-full-width">
              <mat-label>{{'Email' | translate}}</mat-label>
              <input matInput type="email" formControlName="Email" autocomplete="off" required
                (blur)="checkUserExists()" (input)="loginForm.get('Email').markAsTouched()" />
              <mat-icon matSuffix>email</mat-icon>
              <mat-error *ngIf="isControlHasError('Email', 'required')">
                <strong>{{ 'This field is required' | translate }}</strong>
              </mat-error>
              <mat-error *ngIf="isControlHasError('Email', 'pattern')">
                <strong>{{ 'Please enter a valid email address' | translate }}</strong>
              </mat-error>
              <mat-error *ngIf="loginForm.get('Email').hasError('userExists')">
                <strong>{{ 'Email already exists' | translate }}</strong>
              </mat-error>
            </mat-form-field>
          </div>

          <div class="mb-3">
            <mat-label [ngClass]="{'phone-label-touched': loginForm.controls['MobileNumber'].touched ,
                          'phone-label-untouched': !loginForm.controls['MobileNumber'].touched,
                          'mdc-floating-label--required': isRequiredPhoneNumber}"
              class="phone-label mat-mdc-form-field-required-marker ng-star-inserted">
              {{"patient.mobileNumber" | translate }}</mat-label>
            <ngx-intl-tel-input class="intl-tel-input" [preferredCountries]="preferredCountries"
              [enableAutoCountrySelect]="false" [enablePlaceholder]="true"
              [customPlaceholder]="'Enter mobile number' | translate" [searchCountryFlag]="true"
              [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name, SearchCountryField.DialCode]"
              [selectFirstCountry]="false" [selectedCountryISO]="selectedCountryISO" [maxLength]="15"
              [phoneValidation]="true" formControlName="MobileNumber" (ngModelChange)="onPhoneNumberKeyup()"
              (input)="onCountrySearch($event)">
            </ngx-intl-tel-input>
            <mat-error *ngIf="loginForm.controls['MobileNumber'].hasError('invalidPhone')">
              <strong class="phone-error">{{ "patient.invalidPhone" | translate }}</strong>
            </mat-error>
            <mat-error *ngIf="
              isRequiredPhoneNumber &&
              loginForm.controls['MobileNumber'].hasError('required') &&
              loginForm.controls['MobileNumber'].touched
            ">
              <strong class="phone-error">{{ 'admin.required' | translate }}</strong>
            </mat-error>
          </div>

          <div class="mb-3">
            <mat-form-field class="example-full-width">
              <mat-label>{{ 'Password' | translate }}</mat-label>
              <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="Password" autocomplete="off"
                required />
              <button mat-icon-button matSuffix type="button" (click)="togglePasswordVisibility()">
                <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
              </button>
              <mat-error *ngIf="isControlHasError('Password', 'required')">
                <strong>{{ 'This field is required' | translate }}</strong>
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div *ngIf="isOtpLogin">
          <div class="mb-3">
            <mat-form-field class="example-full-width">
              <mat-label>{{'Email' | translate}}</mat-label>
              <input matInput type="email" formControlName="OtpEmail" autocomplete="off" required
                (input)="loginForm.get('OtpEmail').markAsTouched()" />
              <mat-error *ngIf="isControlHasError('OtpEmail', 'required')">
                <strong>{{ 'This field is required' | translate }}</strong>
              </mat-error>
              <mat-error *ngIf="isControlHasError('OtpEmail', 'pattern')">
                <strong>{{ 'Please enter a valid email address' | translate }}</strong>
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="kt-login__actions">
          <ng-container *ngIf="!isOtpLogin && !isSignUp">
            <button (click)="submit(loginForm)" id="kt_login_signin_submit" [class.spinner]="loading"
              class="custom-btn btn-primary" [disabled]="loading || loginForm.invalid">
              {{'LOGIN'| translate}}
            </button>
            <button type="button" class="custom-btn btn-secondary-modern" (click)="toggleOtpLogin()">
              <mat-icon>smartphone</mat-icon>
              Login with OTP
            </button>
          </ng-container>

          <ng-container *ngIf="isOtpLogin">
            <button (click)="sendOtp()" [class.spinner]="loading" class="custom-btn btn-primary"
              [disabled]="loading || !loginForm.get('OtpEmail')?.value || loginForm.get('OtpEmail')?.invalid">
              Send OTP
            </button>
            <button type="button" class="custom-btn btn-secondary-modern" (click)="toggleOtpLogin()">
              <mat-icon>arrow_back</mat-icon>
              Back to Password Login
            </button>
          </ng-container>

          <ng-container *ngIf="isSignUp && isCommonUrl">
            <button (click)="signUp()" id="kt_login_signup_submit" [class.spinner]="loading"
              class="custom-btn btn-primary"
              [disabled]="loading || loginForm.get('Email')?.invalid || loginForm.get('MobileNumber')?.invalid || (loginForm.get('Password')?.value?.length || 0) < 6">
              {{'Sign Up'| translate}}
            </button>
          </ng-container>
        </div>
        <ng-container *ngIf="isCommonUrl">
          <div class="text-center mt-4">
            <span *ngIf="!isSignUp">
              {{ 'New here?' | translate }}
              <a href="javascript:;" (click)="toggleSignUp()" class="forgotFontSize fw-bold ms-1">{{ 'Sign Up' |
                translate
                }}</a>
            </span>
            <span *ngIf="isSignUp">
              {{ 'Already have an account?' | translate }}
              <a href="javascript:;" (click)="toggleSignUp()" class="forgotFontSize fw-bold ms-1">{{ 'Log In' |
                translate
                }}</a>
            </span>
          </div>
          <ng-container>
            <div class="login-divider">
              <span>OR CONTINUE WITH</span>
            </div>

            <div class="social-login-container">

              <!-- Google -->
              <button class="social-btn" (click)="triggerGoogleLogin()">
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/google/google-original.svg" alt="Google" />
              </button>

              <!-- Facebook -->
              <button class="social-btn" (click)="loginWithFacebook()">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                  <path fill="#1877f2"
                    d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                </svg>
              </button>

              <!-- Microsoft -->
              <button class="social-btn" (click)="loginWithMicrosoft()">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 23 23">
                  <path fill="#f35325" d="M1 1h10v10H1z" />
                  <path fill="#81bc06" d="M12 1h10v10H12z" />
                  <path fill="#05a6f0" d="M1 12h10v10H1z" />
                  <path fill="#ffba08" d="M12 12h10v10H12z" />
                </svg>
              </button>

              <!-- LinkedIn -->
              <button class="social-btn" (click)="loginWithLinkedIn()">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                  <path fill="#0077b5"
                    d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.8v8.37h2.8v-4.67c0-.25.02-.5.1-.68a1.14 1.14 0 0 1 1-.77c.76 0 1 .52 1 1.29v4.83h2.8M6.5 8.37a1.37 1.37 0 1 0 0-2.75a1.37 1.37 0 0 0 0 2.75M8 18.5V10.1H5.1v8.4H8Z" />
                </svg>
              </button>

              <!-- Apple -->
              <button class="social-btn" (click)="loginWithApple()">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                  <path fill="#000000"
                    d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M15.97 4.17c.66-.81 1.11-1.93.99-3.06-.96.04-2.13.64-2.82 1.45-.6.69-1.12 1.83-.98 2.94 1.07.08 2.15-.52 2.81-1.33z" />
                </svg>
              </button>
            </div>

            <!-- Hidden Google Button -->
            <div id="googleBtn" class="hidden-google-btn"></div>
          </ng-container>
        </ng-container>
      </form>
    </div>
  </div>
</div>